import { basicValidation } from "../modules/fieldValidation/basicValidation";

export const stringUtil = {
    parseIntegerOrDefault,
    zeroPad,
    capTextLength,
    generateNextSequenceValue,
    uniqueStrings
}


function parseIntegerOrDefault(str: string, defaultValue: number): number {
    if (basicValidation.validateIntegerString(str))
        return parseInt(str);

    return defaultValue;
}

function zeroPad(val:number, digitCount:number)
{
    let str = val.toString();
    while(str.length < digitCount)
        str = '0' + str;

    return str;
}

function capTextLength(val:string, maxLength:number)
{
    if(val.length <= maxLength)
        return val;

    return val.substring(0, maxLength-3) + '...';
}

function generateNextSequenceValue(nameBase:string, namesInUse:string[], separator:string = " ")
{
    // Escape the nameBase so any regex special characters are treated literally.
    const escapedBase = nameBase.replace(/[.*+?^${}()|[\]\\]/g, "\\$&");
    const escapedSeparator = separator.replace(/[.*+?^${}()|[\]\\]/g, "\\$&");

    // Anchored pattern: exactly nameBase, or nameBase + separator + one or more digits.
    const exactPattern = new RegExp(`^${escapedBase}(?:${escapedSeparator}\\d+)?$`);
    if(namesInUse.every(n => !n.match(exactPattern))){
        return nameBase;
    }

    const usedNs: number[] = [];
    const suffixPattern = new RegExp(`^${escapedBase}${escapedSeparator}(\\d+)$`);
    for(const n of namesInUse){
        const match = n.match(suffixPattern);
        if(match){
            usedNs.push(parseInt(match[1]));
        }
    }

    if(usedNs.length === 0)
        return nameBase + separator + "1";

    return nameBase + separator + (Math.max(...usedNs) + 1);
}

function uniqueStrings(values:string[])
{
    const uniqueValues = new Set<string>();
    for(const v of values)
        uniqueValues.add(v);

    return Array.from(uniqueValues);
}

export function forgiveWhitespaceAndCase(str:string)
{
    return str.replace(/\s+/g, '').toLocaleLowerCase();
}